import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Autocomplete, TextField } from '@mui/material';
import { ModalStyled } from '../../../../theme/customizedStyleComponents.js';
import { qcResultTypes } from '../../../../services/common/optionsData.js';
import { updateQcResultStatus } from '../../../../services/clinicPortalServices/qcResultService';
import toastr from 'toastr';    

import GridAutocomplete from '../../../common/GridAutocomplete';
export default class Statusupdatepopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            status: '',
            comments: ''
        };
    }

    componentDidMount() {        
        this.setState({
            Statuses: qcResultTypes[0],
            comments: '',
            status: ''
        });

    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    getButtonVariant = () => {
        switch (this.state.status) {
            case 'Approved':
                return 'success'; // green
            case 'Rejected':
                return 'danger';  // red
            case 'Need Review':
                return 'warning'; // yellow
            default:
                return 'primary'; // default blue
        }
    };


    handleSave = () => {
        
        const { comments, status } = this.state;
        let params = {
            ids: this.props.selectedRows.map((row) => row._id),
            status: status,
            comment: comments
        };        
        if (!comments) {
            toastr.error("Please add a comments before submitting.");
            return;
        }
        if (!status) {
            toastr.error("Please add a status before submitting.");
            return;
        }
        updateQcResultStatus(params).then((response) => {                 
            if (response.data?.success) {
                toastr.success(response.data.message || 'Updated successfully!');
                this.setState({
                    status: '',
                    comments: ''
                });
                this.props.loadGridData();
                this.props.handleClose();
            }
            else {
                toastr.error("Error updating QC Status: " + (response.data?.message || 'Unknown error'));
            }
        });
    };

    render() {
        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update QC Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mt-4">
                            <GridAutocomplete
                                options={qcResultTypes}
                                value={this.state.status}  
                                onChange={(event, newValue) => {
                                    this.setState({ status: newValue });
                                }}
                                getOptionLabel={(option) => (option ? option : '')}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label="Status *" />
                                )}
                            />

                        </div>
                        <div className="col-12 mt-3">
                            <label htmlFor="comments" className="form-label fw-bold">
                                Comments
                            </label>
                            <textarea
                                id="comments"
                                className="form-control"
                                rows="3"
                                value={this.state.comments}
                                onChange={(e) => this.setState({ comments: e.target.value })}
                                placeholder="Enter your comments here..."
                            ></textarea>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                    <Button variant={this.getButtonVariant()} onClick={this.handleSave}>
                         {this.state.status ? `Update to ${this.state.status}` : 'Save'}
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}